import React, { useEffect, useMemo, useState, useContext } from 'react';
import ManagementHeaderNav from '../../components/HeadersNav/ManagementHeaderNav';
import { Box, CircularProgress, Grid, MenuItem, Paper, TextField, Typography, Button , Chip } from '@mui/material';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { setAssignmentListDDL, setCallbackMaxNumberDDL } from '../../store/ddlReducer';
import { useSelector, useDispatch } from 'react-redux';
import ApiService from '../../functions/apiService';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import MyTable from '../../components/Schedule/MyTable';
import AuthContext from '../../context/AuthContext';
import CollapseComponent from '../../components/Schedule/CollapseComponent';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import EmptyState from '../../components/Error/EmptyState';
import { Row, Col } from "react-bootstrap";

export default function CallBackFunction() {
    const { user, v3Data } = useContext(AuthContext);
    let nIntervId;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [resData, setResData] = useState({});
    let AssignmentListDDL = useSelector((state) => state.ddlReducer.AssignmentListDDL)
    let CallbackMaxNumberDDL = useSelector((state) => state.ddlReducer.CallbackMaxNumberDDL)
    const [timerType, setTimerType] = useState('Seconds');
    const [timer, setTimer] = useState(5);
    const [callBackList, setCallBackList] = useState([]);
    const [empModal , setEmpModal] = useState(false);
    const [empData , setEmpData] = useState([]);
    const [closeModal , setCloseModal] = useState(false);
    const [rowData , setRowData] = useState([]);
    const [closeData , setCloseData] = useState([]);
    const [hours, setHours] = useState('');
    const [reason , setReason] = useState('');

    const [columns, setColumns] = useState([
        {
            field: "date",
            headerName: "Timestamp",
            flex: 1,
            minWidth: 170,
            hideable: false,
        },
        {
            field: "created_by",
            headerName: "Created By",
            flex: 1,
            minWidth: 200,
        },
        {
            field: "assignment",
            headerName: "Assignment",
            flex: 1,
            minWidth: 100,
            maxWidth:100
        },
        {
            field: "called_to",
            headerName: "Call #",
            flex: 1,
            minWidth: 100,
            maxWidth:100
        },
        {
            field: "filled_by",
            headerName: "Filled By",
            flex: 1,
            minWidth: 260,
            maxWidth: 260,
            renderCell: (params) => {
                return (
                     <p
                        style={{
                            margin: "0px",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                        }}
                    >
                        {params?.row?.filled_by}
                    </p>
                )
            }
        },
        {
            field: "status",
            headerName: "Status",
            flex: 1,
            minWidth: 160,
            renderCell: (params) => {
                return (
                    <>
                        <Chip
                            sx={{
                                color: '#ffffff',
                                height: '32px',
                                backgroundColor:params?.row?.status == 'Deleted' ? '#000000' : params?.row?.status == 'Filled' ? 'green' : params?.row?.status == 'Pending' ? 'orange' : '#000000',
                                px: 1,
                                flexShrink: 0,
                                width:'90%'
                            }}
                            label={params?.row?.status}
                        />
                    </>
                )
            }
        },
        {
            field: "closed_by",
            headerName: "Closed By",
            flex: 1,
            minWidth: 170,
            renderCell: (params) => {
                return (
                    params?.row?.closed_by == null ? 
                    <>
                        <ButtonTheme variant="filled" color='primary' className='px-4' disabled={params?.row?.status != 'Filled'} onClick={()=> {
                            setCloseModal(true)
                            CallbackCloseReq(params?.row)
                            setRowData(params?.row)
                        }}>
                            Close
                        </ButtonTheme>
                    </>
                    :
                    <p style={{margin:'0px'}}>{params?.row?.closed_by}</p>
                )
            }
        },
    ]);

    const {
        register,
        formState: { errors, isValid },
        handleSubmit,
        setError,
        setValue,
        reset,
    } = useForm({});

    const loadDropDowns = () => {
        ApiService.get('/getCallbackMaxNumberDDL', {}, 'getCallbackMaxNumberDDL')
            .then(({ data }) => {
                dispatch(setCallbackMaxNumberDDL(data));
            }).catch(() => {
                toast.error("Error")
            })
        ApiService.get('/getAssignmentListDDL', {}, 'getAssignmentListDDL')
            .then(({ data }) => {
                dispatch(setAssignmentListDDL(data));
            }).catch(() => {
                toast.error("Error")
            })
    }

    useEffect(() => {
        loadDropDowns()
        getCallBackList()
        return () => {
            clearInterval(nIntervId)
        }
    }, [])

    const getCallBackList = () => {
        setLoading(true)
        ApiService.get('/callback-history')
            .then((data) => {
                setCallBackList(data?.data?.result)
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            });
    };

    const addCallBack = (formData) => {
        const body = {
            number: formData?.CallBack,
            assignment: formData?.Assignment,
            call_no: formData?.Call,
        }
        ApiService.post('/create-callback', body)
            .then((data) => {
                toast.success(data?.message)
                getCallBackList(false)
                reset()
                navigate(`/firehouse/callback/${data?.batch_number}`)
            })
            .catch((error) => {
                if (error.status == 422) {
                    Object.keys(error.data.errors).map((err) => (
                        toast.error(error.data.errors[err][0])
                    ))
                }
                else {
                    toast.error(error.message)
                }
            })
    }

    const onSubmit = (formData) => {
        addCallBack(formData, reset);
    };

    useEffect(() => {
        ApiService.get('/callback-admin-current-request')
            .then((res) => {
                if(res?.data?.batch_number != null){
                    navigate(`/firehouse/callback/${res?.data?.batch_number}`);
                }
                else{
                    return ''
                }
            }).catch(({ error }) => {
                console.log('error', error)
            });
    }, [])

    const CallbackCloseReq = (data) => {
        const body = {
            Shift_Date : data?.shift_date,
            Shift_Number: data?.shift_number,
        }
        ApiService.post('/callback-close-request', body)
            .then((data) => {
                setCloseData(data || [])
            })
            .catch((error) => {
                console.log(error || 'error')
            })
    }

    useEffect(()=>{
        setHours(closeData?.callback_hours)
    }, [closeData])

    const CallbackCloseReqSave = () => {
        const body = {
            Shift_Date : rowData?.shift_date,
            Shift_Number: rowData?.shift_number,
            adjust_hours : hours,
            log_text : reason
        }
        ApiService.post('/callback-close-request-save', body)
            .then((data) => {
                toast.success(data?.message || 'Callback closed successfully.')
                setCloseModal(false)
                getCallBackList()
            })
            .catch((error) => {
                toast.error(error.message || 'error')
            })
    }


    return <>
        {/* <ManagementHeaderNav /> */}
        <Paper className='p-3' style={{ marginTop: "1rem", maxWidth: '94vw', overflowX: 'auto', }}>
            <Typography variant="h5">Create CALLBACK</Typography>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2} className='mb-1'>
                    <Grid item xs={6} md={2} className='mt-2'>
                        <label style={{ fontSize: '14px' }}>Callback</label>
                        <TextField
                            {...register("CallBack", { required: "CallBack is required" })}
                            className='mt-1 w-100' color='secondary' variant="outlined"
                            select size='small'
                            InputProps={{
                                sx: {
                                    height: '48px',
                                    fontSize: '14px'
                                }
                            }}
                        >
                            {CallbackMaxNumberDDL.map(item => {
                                return <MenuItem key={item} value={item} >{item} </MenuItem>
                            })}
                        </TextField>
                    </Grid>

                    <Grid item xs={6} md={2} className='mt-2'>
                        <label style={{ fontSize: '14px' }}>Assignment</label>
                        <TextField
                            {...register("Assignment", { required: "Assignment is required" })}
                            className='mt-1 w-100' color='secondary' variant="outlined"
                            select size='small'
                            InputProps={{
                                sx: {
                                    height: '48px',
                                    fontSize: '14px'
                                }
                            }}
                        >
                            {AssignmentListDDL.map(item => {
                                return <MenuItem key={item.SO_Value} value={item.SO_Value}>{item.SO_Desc} </MenuItem>
                            })}

                        </TextField>
                    </Grid>

                    <Grid item xs={6} md={2} className='mt-2'>
                        <label style={{ fontSize: '14px' }}>Call #</label>
                        <TextField size='small'
                            {...register("Call", { required: "Call is required" })}
                            className='mt-1 w-100' color='secondary' variant="outlined"
                            placeholder='24-0000'
                            InputProps={{
                                sx: {
                                    height: '48px',
                                    fontSize: '14px'
                                }
                            }}
                        >
                        </TextField>
                    </Grid>

                    {v3Data?.CALLBACK_TEMPLATE_PAGE === 'true' &&
                        <Grid item xs={12} md={4.5}>
                            <label className="h6 text-black" style={{ fontSize: '14px' }}>Time interval</label>
                            <div style={{ display: 'flex', alignItems: 'baseline' }}>
                                <div className="input-group" style={{ marginRight: '10px', maxHeight: '34px', marginTop: '8px' }}>
                                    <input type="text" className="form-control shadow-none"
                                        style={{ maxWidth: '50px', fontSize: '12px' }}
                                        value={timer}
                                        onChange={(e) => setTimer(Number(e.target.value))}
                                    />
                                    <select className="form-select shadow-none" style={{ fontSize: '12px', cursor: 'pointer', maxWidth: '100px' }}
                                        value={timerType}
                                        onChange={(e) => setTimerType(e.target.value)}>
                                        <option value="Seconds">Seconds</option>
                                        <option value="Minutes">Minutes</option>
                                    </select>
                                </div>
                                <Box sx={{ display: 'flex', marginTop: '4px' }}>
                                    <Button className='mx-1 my-1' style={{ fontSize: '12px', padding: '0px 10px' }} variant="outlined" color='secondary' onClick={(e) => { setTimer(10); setTimerType('Minutes') }}>10 min</Button>
                                    <Button className='mx-1 my-1' style={{ fontSize: '12px', padding: '0px 10px' }} variant="outlined" color='secondary' onClick={(e) => { setTimer(5); setTimerType('Minutes') }}>5 min</Button>
                                    <Button className='mx-1 my-1' style={{ fontSize: '12px', padding: '0px 10px' }} variant="outlined" color='secondary' onClick={(e) => { setTimer(2); setTimerType('Minutes') }}>2 min</Button>
                                    <Button className='mx-1 my-1' style={{ fontSize: '12px', padding: '0px 10px' }} variant="outlined" color='secondary' onClick={(e) => { setTimer(1); setTimerType('Minutes') }}>Last Minute</Button>
                                </Box>
                            </div>
                        </Grid>
                    }

                    <Grid item xs={6} md={1.5}>
                        <ButtonTheme disabled={saving || !isValid} type='submit' variant="filled" color='primary' className='px-4' style={{ marginTop: '38px' }}>
                            Callback
                        </ButtonTheme>
                    </Grid>
                </Grid>
            </form>
        </Paper >

        <Paper className="p-3 font-fam" style={{ marginTop: "1rem" }}>
            {loading ? 
                <Box className="w-100 h-100 d-flex justify-content-center align-items-center">
                    <CircularProgress />
                </Box>
                : 
                <>
                    {callBackList && callBackList.length > 0 ? 
                        <div>
                            <CollapseComponent
                                name={'Callback History'}
                                rows={callBackList}
                                columns={columns}
                                checkboxSelection={false}
                                hideFooter={true}
                                open={true}
                            />
                        </div>
                        :
                        <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 380 }}>
                            <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                            <span className='mt-4' style={{ color: '#555555' }}>
                                No Callback Found
                            </span>
                        </div>
                    }
                    
                </>
            }
        </Paper>

        <Modal show={empModal} onHide={() => setEmpModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Filled by Employees List</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ color: '#555555' , padding:'6px' }}>
                    {empData || 'No any Employee'}
                </div>
            </Modal.Body>
        </Modal>

        <Modal show={closeModal} onHide={() => {
                setCloseModal(false)
                setCloseData([])
            }}>
            <Modal.Header closeButton>
                <Modal.Title>Close Callback</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <p style={{marginBottom:'8px' , fontSize:'20px', fontWeight:'600'}}>{closeData?.message || ''}</p>
                    <p style={{marginBottom:'10px'}}>Filled by : <strong style={{color:'green'}}>{closeData?.fill_by_emp	|| ''}</strong></p>
                </div>

                <div>
                    <p style={{marginTop:'10px' , marginBottom:'2px'}}>Hours</p>
                    <TextField
                        value={hours}
                        InputProps={{
                          sx: {
                            height: '40px',
                            fontSize: '14px'
                          }
                        }}
                        onChange={(e) => setHours(e.target.value)}
                    />
                </div>

                <div>
                    <p style={{marginTop:'10px' , marginBottom:'2px'}}>Reason</p>
                    <TextField
                        value={reason}
                        placeholder='Please add reason'
                        fullWidth
                        InputProps={{
                          sx: {
                            height: '48px',
                            fontSize: '14px'
                          }
                        }}
                        onChange={(e) => setReason(e.target.value)}
                    />
                </div>
                <Row>
                    <Col md='auto'>
                        <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setCloseModal(false)}>
                            Cancel
                        </ButtonTheme>
                    </Col>
                    <Col md='auto'>
                        <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => CallbackCloseReqSave()}>
                            Save
                        </ButtonTheme>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
        

    </>
}